import { UserOutlined } from "@ant-design/icons"
import { Avatar, Dropdown, Menu } from "antd"
import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { logout } from "../../redux/actionCreators/auth"
import { TextTag as Text, Logo } from "../../atoms"
import Separator from "../../components/Separator/Separator"
import _ from "../../utils/lodashUtils"
import "./AvatarDropDown.scss"
import heartdropdown from "../../assets/images/partner-menu.svg"
import myprofile from "../../assets/images/profile-menu.svg"
import help from "../../assets/images/help-menu.svg"
import logoutImg from "../../assets/images/logout-menu.svg"
import outline from "../../assets/images/avatar-outline.svg"
import {
  GET_ROBO_IMAGE,
  PARTNER_LABEL,
  LOGOUT_BUTTON,
  PROFILE_LABEL,
  HELP_LABEL,
} from "../../constants/messages"

class AvatarDropDown extends React.Component {
  render() {
    const { isAuthenticated, logout, loading } = this.props

    const menu = (
      <Menu className="drop_down_menu">
        <Menu.Item key="0">
          <div className="link-wrapper">
            <Link to="/my-partner">
              <img src={heartdropdown} alt="partner" />
              {PARTNER_LABEL}
            </Link>
          </div>
          <Separator />
        </Menu.Item>
        <Menu.Item key="1">
          <div className="link-wrapper">
            <Link
              to="/contact"
              onClick={() => localStorage.removeItem("isPathFromLogin")}
            >
              <img src={myprofile} alt="myprofile" />
              {PROFILE_LABEL}
            </Link>
          </div>
          <Separator />
        </Menu.Item>

        <Menu.Item key="2">
          <div className="link-wrapper">
            <Link to="/get-help">
              <img src={help} alt="help" />
              {HELP_LABEL}
            </Link>
          </div>
          <Separator />
        </Menu.Item>

        <Menu.Item key="3">
          <div className="link-wrapper">
            {/* <Link onClick={logout}> */}
            <div className="link-tag-replacement" onClick={logout}>
              <img src={logoutImg} alt="logout" />
              {LOGOUT_BUTTON}
            </div>
            {/* </Link> */}
          </div>
        </Menu.Item>
      </Menu>
    )

    const avatarDropDown = (
      <Dropdown overlay={menu} trigger={["click"]}>
        {_.get(this.props.user, "profile_image") ? (
          <div className="menu-img">
            <div className="outline-border">
              <img src={outline} className="outline" alt="oval boundary" />
              <Avatar
                className="avatar-img"
                size={40}
                src={_.get(this.props.user, "profile_image")}
              />
            </div>
            <div className="display-name">
              <Text textType="smallTextPrimary">
                {_.get(this.props.user, "display_name")}
              </Text>
            </div>
          </div>
        ) : (
          <div>
            {_.get(this.props.user, "display_name") ? (
              <div className="menu-img">
                <div className="outline-border">
                  <img src={outline} className="outline" alt="oval boundary" />
                  <Avatar
                    className="avatar-img"
                    size={40}
                    src={GET_ROBO_IMAGE(_.get(this.props.user, "display_name"))}
                  ></Avatar>
                </div>
                <div className="display-name">
                  <Text textType="smallTextPrimary">
                    {_.get(this.props.user, "display_name")}
                  </Text>
                </div>
              </div>
            ) : (
              <div className="menu-img">
                <div className="outline-border">
                  <img src={outline} className="outline" alt="oval boundary" />
                  <Avatar
                    className="avatar-img"
                    size={40}
                    icon={<UserOutlined />}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </Dropdown>
    )
    return (
      <div className="header">
        <Logo size="small" />
        <div id="AvatarDropDown">
          {!loading && (
            <Fragment>{isAuthenticated ? avatarDropDown : null}</Fragment>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  user: state.auth.user,
  partnerDetails: state.invitePeople.partnerDetails,
})

export default connect(mapStateToProps, { logout })(AvatarDropDown)
